export default "__VITE_ASSET__ed7358f6__"